if (!customElements.get('multi-swatch-select')) {
  customElements.define(
    'multi-swatch-select',
    class MultiSwatchSelect extends HTMLElement {
      constructor() {
        super();
        this.variantData = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.countElement = this.querySelector('[data-multi-swatch-select-count]');
        this.errorElement = this.querySelector('[data-multi-swatch-select-error]');
        this.addEventListener('change', this.onSwatchChange.bind(this));
      }

      onSwatchChange() {
        this.updateSelectedCount();
        this.clearErrorMessage();
      }

      updateSelectedCount() {
        if (!this.countElement) return;
        const count = this.getCheckedInputs().length;
        this.countElement.textContent =
          count === 1
            ? window.multiSwatchSelectStrings.oneSelected
            : window.multiSwatchSelectStrings.otherSelected.replace('[count]', count);
      }

      getCheckedInputs() {
        return Array.from(this.querySelectorAll('input[type="checkbox"]:checked'));
      }

      getSelectedItems() {
        return this.getCheckedInputs()
          .map((input) => {
            const variant = this.variantData.find((variant) => variant.option1 === input.value && variant.available);
            return variant ? { id: variant.id, quantity: 1 } : null;
          })
          .filter(Boolean);
      }

      showErrorMessage(message) {
        if (!this.errorElement) return;
        this.errorElement.textContent = message;
        this.errorElement.hidden = false;
      }

      clearErrorMessage() {
        if (!this.errorElement) return;
        this.errorElement.hidden = true;
      }
    }
  );
}
